module.exports = __webpack_public_path__ + "img/title-shiba.977ad925.png";